import { z } from 'zod';
/**
 * Lists of the API that people browse in a table (after Corly): the server sorts, filters and
 * pages; a page says how many there are in all. Offset pages - lists of a firm stay small
 * enough to count - in a stable order, `id` as the last key (AGENTS.md, API-Regeln).
 */
/** The page sizes a table offers; the API refuses larger pages. */
export const PAGE_SIZES = [10, 25, 50, 100];
export const DEFAULT_PAGE_SIZE = 25;
/** `field:asc` or `field:desc`; which fields a list sorts by, it says itself. */
export const SortParam = z
    .string()
    .regex(/^[a-zA-Z]{1,40}:(asc|desc)$/)
    .meta({ id: 'SortParam', description: 'Field and direction, e.g. `occurredAt:desc`.' });
/** What every list query has: page, size, free text, sort. */
export const listQueryShape = {
    page: z.coerce.number().int().min(1).max(100_000).default(1),
    limit: z.coerce
        .number()
        .int()
        .refine((n) => PAGE_SIZES.includes(n), 'one of 10, 25, 50, 100')
        .default(DEFAULT_PAGE_SIZE),
    q: z.string().trim().min(1).max(200).optional(),
    sort: SortParam.optional(),
};
/** A page of a list: its rows, how many there are in all, which page of which size. */
export const pageOf = (item, id) => z
    .object({
    items: z.array(item),
    total: z.int().nonnegative(),
    /** The page served - an out-of-range request gets the last one. */
    page: z.int().positive(),
    pageSize: z.int().positive(),
})
    .meta({ id });
/** The sort a query asks for, if the list knows the field; otherwise `null`. */
export function parseSort(value, fields) {
    if (!value)
        return null;
    const [field, direction] = value.split(':');
    const known = fields.find((f) => f === field);
    return known && (direction === 'asc' || direction === 'desc')
        ? { field: known, direction }
        : null;
}
//# sourceMappingURL=lists.js.map